import styled from "styled-components/macro";
import { device } from "../../device";

export const StyledPercentageChange = styled.div`
  display: flex;
`;

export const Value = styled.div`
  font-size: 0.775rem;
  color: #3c4350;
  font-weight: normal;

  @media ${device.mobileM} {
    font-size: 0.875rem;
  }
  @media ${device.tablet} {
    font-size: 1.5rem;
  }
`;

export const Icon = styled.svg`
  max-width: 100%;
  height: auto;
  padding-right: 5px;
  @media ${device.tablet} {
    padding-right: 10px;
  }
`;
